module.exports = __webpack_public_path__ + "img/preisfinder.178b0741.png";